<template>
    <div v-show="show" id="PolygonCreater">
        <div id="PolygonBG"></div>
        <div class="tab polygon">
            <div class="PolygonBtn" v-bind:class="{ active: tabType == 'AngleTool' }" value="AngleTool"
                @click="ctrlPolygonView($event)">
                <span>角度</span>
            </div>
            <div class="PolygonBtn" v-bind:class="{ active: tabType == 'TriangleTool' }" value="TriangleTool"
                @click="ctrlPolygonView($event)">
                <span>三角形</span>
            </div>
            <div class="PolygonBtn" v-bind:class="{ active: tabType == 'PolygonTool' }" value="PolygonTool"
                @click="ctrlPolygonView($event)">
                <span>多邊形</span>
            </div>
        </div>
        <img class="close-btn" src="@/assets/art/math_tool/polygon/close_1.png" @click="ctrlPolygon" />
        <!-- 角度工具 -->
        <div v-show="tabType == 'AngleTool'" id="AngleTool" class="PolgonView">
            <span class="PolgonText">請輸入角度</span>
            <input class="AngleInput" type="number" placeholder="請輸入角度" v-model="angleToolInput"
                @change="angleUpdate();" />
            <div class="PolygonOKBtn" style="left: 15px; top: 115px" @click="createImage()"> 確定 </div>
            <div class="PolygonOKBtn" style="left: 15px; top: 175px" @click="resetAngleValue()"> 歸零 </div>
            <div class="angleCanvas-wrapper">
                <canvas id="AngleCanvas" width="300" height="300"></canvas>
            </div>
        </div>
        <!-- 三角形工具 -->
        <div v-show="tabType == 'TriangleTool'" id="TriangleTool" class="PolgonView">
            <div id="AngleChoice" class="triangle-block">
                <img v-show="triangleType == 'angle'" id="AngleBG"
                    src="@/assets/art/math_tool/polygon/TriangleAngle.png"
                    style="position: absolute; width: 100%; height: 100%; display: block" />
                <input class="TriangleInput" style="top: 76px; left: 56px" type="text"
                    v-model="triangleToolInput.angleA" @input="handleTriangleAngles[0]" index="0" />
                <input class="TriangleInput" style="top: 76px; left: 172px" type="text"
                    v-model="triangleToolInput.angleB" @input="handleTriangleAngles[1]" index="1" />
                <input class="TriangleInput" style="top: 76px; left: 292px" type="text"
                    v-model="triangleToolInput.angleC" @input="handleTriangleAngles[2]" index="2" />
            </div>
            <div id="LengthChoice" class="triangle-block">
                <img v-show="triangleType == 'length'" id="LengthBG"
                    src="@/assets/art/math_tool/polygon/Trianglength.png"
                    style="position: absolute; width: 100%; height: 100%; display: block" />
                <input class="TriangleInput" style="top: 81px; left: 56px" type="text"
                    v-model="triangleToolInput.lengthA" @input="handleTriangleLengths[0]" index="0" />
                <input class="TriangleInput" style="top: 81px; left: 172px" type="text"
                    v-model="triangleToolInput.lengthB" @input="handleTriangleLengths[1]" index="1" />
                <input class="TriangleInput" style="top: 81px; left: 292px" type="text"
                    v-model="triangleToolInput.lengthC" @input="handleTriangleLengths[2]" index="2" />
            </div>
            <img v-show="triangleType == 'length'" id="TriangleAngleBtn" class="triangle-block"
                src="@/assets/art/math_tool/polygon/TriangleAngle_s1.png" @click="ctrlTriangleView()" />
            <img v-show="triangleType == 'angle'" id="TriangleLengthBtn" class="triangle-block"
                src="@/assets/art/math_tool/polygon/Trianglength_s1.png" @click="ctrlTriangleView()" />
            <div class="PolygonOKBtn" @click="createImage()" style="right: 10px; bottom: 10px"> 確定 </div>
            <div class="triangleCanvas-wrapper">
                <canvas id="TriangleCanvas" width="200" height="200"></canvas>
            </div>
        </div>
        <!-- 多邊形工具 -->
        <div v-show="tabType == 'PolygonTool'" id="PolygonTool" class="PolgonView">
            <span class="PolgonText">請輸入邊形</span>
            <input id="side-input" class="AngleInput" type="text" v-model="polygonToolInput" @change="polgonUpdate()" />
            <span id="side-check">請確認邊數大於3</span>
            <div class="PolygonOKBtn" style="left: 15px; top: 115px" @click="createImage()"> 確定 </div>
            <div class="polygonCanvas-wrapper">
                <canvas id="PolygonCanvas" width="250" height="250"></canvas>
            </div>
        </div>
    </div>
</template>

<script>
import { fabric } from 'fabric';
import { DEBOUNCE } from '../../js/common/debounce';
import PainterProxy from '@/js/painter/proxy';
import DEFINE from '@/js/painter/define';
import { store } from '@/store';
import { TOOLS } from '@/js/toolbar/tools';

export default {
    name: "PolygonCreater",
    data: function () {
        return {
            //整個UI顯示
            show: false,
            //切換工具
            tabType: "AngleTool",
            //各工具預覽畫布
            angleCanvas: null,
            triangleCanvas: null,
            polygonCanvas: null,
            //角度工具
            angleToolInput: 90,
            //三角形工具
            triangleType: "angle",
            triangleToolInput: {
                angleA: 60,
                angleB: 60,
                angleC: 60,
                lengthA: 3,
                lengthB: 3,
                lengthC: 3,
            },
            //多邊形工具
            polygonToolInput: 3,

            handleTriangleAngles: [],
            handleTriangleLengths: []
        };
    },
    methods: {
        //開關角度與多邊形UI
        ctrlPolygon() {
            if (this.show) {
                this.show = false;
            } else {
                //須關閉工具箱，待對接
                // menuTools.style.display = 'none';

                this.show = true;
            }
            //統計使用數據，待功能完成
            // postToolClick('角度與多邊形');
        },
        //切換對應介面
        ctrlPolygonView(evt) {
            this.tabType = evt.currentTarget.getAttribute("value");
        },
        //產生實際圖形
        createImage() {
            const proxy = PainterProxy.getInstance();
            proxy.changeTool(null);
            //產生圖形
            switch (this.tabType) {
                case "AngleTool":
                    proxy.changeTool(DEFINE.TOOLS.ANGLE_TOOL, this.angleToolInput, () => {
                        proxy.changeTool(null);
                        store.nowTool = TOOLS.SELECTION.TOOL;
                    });
                    break;
                case "TriangleTool":
                    proxy.changeTool(DEFINE.TOOLS.TRIANGLE_TOOL, {
                        type: this.triangleType,
                        input: this.triangleToolInput
                    }, () => {
                        proxy.changeTool(null);
                        store.nowTool = TOOLS.SELECTION.TOOL;
                    });
                    break;
                case "PolygonTool":
                    proxy.changeTool(DEFINE.TOOLS.POLYGON_TOOL, this.polygonToolInput, () => {
                        proxy.changeTool(null);
                        store.nowTool = TOOLS.SELECTION.TOOL;
                    });

                    break;
            }

            //關閉介面
            this.ctrlPolygon();
        },
        //#region 角度
        //角度變化時判定
        angleUpdate() {
            // console.log("現在角度", this.angleToolInput);

            //若為空則填0
            if (this.angleToolInput.length == 0) {
                this.angleToolInput = 0;
            }

            //清除數字前的0
            // this.angleToolInput = parseInt(this.angleToolInput);
            this.angleToolInput += 1;
            this.angleToolInput -= 1;
            //避免大於360度
            if (this.angleToolInput > 360) {
                this.angleToolInput %= 360;
            } else if (this.angleToolInput < 0) {
                this.angleToolInput %= 360;
                this.angleToolInput += 360;
            }

            this.preViewAngleImage();
        },
        //重置角度
        resetAngleValue() {
            this.angleToolInput = 0;
            this.angleUpdate();
        },
        //預覽角度圖形
        preViewAngleImage() {
            this.angleCanvas.clear();

            //繪圖起點座標
            let origX = 150;
            let origY = 150;

            //線段長度
            let angle = this.angleToolInput;
            let lineLength = 125;
            //產生水平線
            let horizontal = new fabric.Line([origX, origY, origX + lineLength, origY], {
                stroke: DEFINE.COLOR.MATH_TOOL.BLACK_0_0_0,
                strokeWidth: 5,
                transparentCorners: false,
                originX: "left",
                originY: "center"
            });

            //產生角度線
            let rect = new fabric.Line([origX + 2.5, origY, origX + lineLength, origY], {
                angle: -angle,
                stroke: DEFINE.COLOR.MATH_TOOL.BLACK_0_0_0,
                strokeWidth: 5,
                transparentCorners: false,
                originX: "left",
                originY: "center"
            });

            //產生扇形
            let r = 30;
            let sector = new fabric.Circle({
                radius: r,
                left: origX,
                top: origY,
                angle: -angle,
                startAngle: 0,
                endAngle: angle,
                fill: DEFINE.COLOR.TRANSPARENT,
                stroke: DEFINE.COLOR.MATH_TOOL.BLUE_0_175_239,
                strokeWidth: r * 2,
                originX: "center",
                originY: "center"
            });

            //產生角度文字
            let angleText = new fabric.Text(angle + "°", {
                left: origX - 25,
                top: (angle < 180) ? origY + 10 : origY - 50,
                fontFamily: "Arial",
                fill: DEFINE.COLOR.MATH_TOOL.BLUE_0_31_95,
            });

            //將產生的物件群組
            let group = new fabric.Group([sector, horizontal, rect, angleText], {
                originX: "center",
                originY: "center",
                selectable: false,
                evented: false
            });

            this.angleCanvas.add(group);
            this.angleCanvas.renderAll();
        },
        //#endregion

        //#region 三角形
        //切換產生類型
        ctrlTriangleView() {
            this.triangleType == "angle" ? this.triangleType = "length" : this.triangleType = "angle";
            this.preViewTriangleImage()
        },
        //角度變化時判定
        editTriangleAngle(inputIndex) {
            //使用者輸入後若有需要改動，則改動下一順位欄位
            let keys = ['angleA', 'angleB', 'angleC'];  //改動欄位順序用
            let angleInput = this.triangleToolInput;
            let temp = null;    //交換用

            //非數字清除
            angleInput[keys[inputIndex]] = angleInput[keys[inputIndex]].replace(/\D/g, '');

            //字串轉數字
            for (let i = 0; i <= 2; i++) {
                angleInput[keys[i]] = Number(angleInput[keys[i]]);
            }

            if(angleInput[keys[inputIndex]] == 0) return;

            //角度不可大於178（180 - 1 - 1）
            if (angleInput[keys[inputIndex]] > 178) angleInput[keys[inputIndex]] = 178;

            //將使用者輸入欄位改為第一順位
            if (inputIndex == 1) {
                temp = keys[0];
                keys[0] = keys[1];
                keys[1] = keys[2];
                keys[2] = temp;
            } else if (inputIndex == 2) {
                temp = keys[2];
                keys[2] = keys[1];
                keys[1] = keys[0];
                keys[0] = temp;
            }

            //判定三角形規則，若有不符，改動下一個值（第一欄位為使用者改動欄位）
            //三角形規則，角度總和為180
            angleInput[keys[1]] = 180 - (angleInput[keys[0]] + angleInput[keys[2]]);

            this.preViewTriangleImage(100, 100);
        },
        //邊長變化時判定
        editTriangleLength(inputIndex) {
            //使用者輸入後若有需要改動，則改動下一順位欄位
            let keys = ['lengthA', 'lengthB', 'lengthC'];  //改動欄位順序用
            let lengthInput = this.triangleToolInput;
            let temp = null;    //交換用

            //非數字清除
            lengthInput[keys[inputIndex]] = lengthInput[keys[inputIndex]].replace(/\D/g, '');

            //字串轉數字
            for (let i = 0; i <= 2; i++) {
                lengthInput[keys[i]] = Number(lengthInput[keys[i]]);
            }
            if (lengthInput[keys[inputIndex]] == 0) return;
            //邊長不可大於99
            if (lengthInput[keys[inputIndex]] > 99) lengthInput[keys[inputIndex]] = 99;

            //將使用者輸入欄位改為第一順位
            if (inputIndex == 1) {
                temp = keys[0];
                keys[0] = keys[1];
                keys[1] = keys[2];
                keys[2] = temp;
            } else if (inputIndex == 2) {
                temp = keys[2];
                keys[2] = keys[1];
                keys[1] = keys[0];
                keys[0] = temp;
            }

            //判定三角形規則，若有不符，改動下一個值（第一欄位為使用者改動欄位）
            //三角形規則，任意兩邊和大於第三邊、任意兩邊差小於第三邊
            if (lengthInput[keys[0]] + lengthInput[keys[1]] <= lengthInput[keys[2]])
                lengthInput[keys[1]] = lengthInput[keys[2]] - lengthInput[keys[0]] + 1;

            if (lengthInput[keys[0]] - lengthInput[keys[1]] >= lengthInput[keys[2]])
                lengthInput[keys[1]] = lengthInput[keys[0]] - lengthInput[keys[2]] + 1;

            this.preViewTriangleImage(100, 100);
        },
        //預覽三角形圖形
        preViewTriangleImage() {
            this.triangleCanvas.clear();

            let radius = 80;    //三角形大小半徑
            let rotate = 0;     //紀錄旋轉度數（若為垂直需要旋轉）

            //三點座標
            let pointArray = [];
            //紀錄三邊弧度
            let radianArray = [];

            if (this.triangleType == "angle") {
                //三角形三個角度（）
                let triangleSide = {
                    a: this.triangleToolInput.angleA,
                    b: this.triangleToolInput.angleB,
                    c: this.triangleToolInput.angleC
                }
                this.sortSide(triangleSide);

                //角度越大，對邊越長
                radianArray.push(triangleSide.a / 180 * Math.PI * 2);
                radianArray.push(triangleSide.b / 180 * Math.PI * 2);
                radianArray.push(triangleSide.c / 180 * Math.PI * 2);
            } else {
                //三角形三邊長
                let triangleSide = {
                    a: this.triangleToolInput.lengthA,
                    b: this.triangleToolInput.lengthB,
                    c: this.triangleToolInput.lengthC
                }
                this.sortSide(triangleSide);

                let a = triangleSide.a;
                let b = triangleSide.b;
                let c = triangleSide.c;

                radianArray.push(Math.acos((b ** 2 + c ** 2 - a ** 2) / (2 * b * c)) * 2);
                radianArray.push(Math.acos((a ** 2 + c ** 2 - b ** 2) / (2 * a * c)) * 2);
                radianArray.push(Math.acos((a ** 2 + b ** 2 - c ** 2) / (2 * a * b)) * 2);
            }

            radianArray[1] += radianArray[0];
            radianArray[2] += radianArray[1];

            for (let i = 0; i < radianArray.length; i++) {
                //計算新的x, y座標
                let x = radius * Math.cos(radianArray[i]);
                let y = radius * Math.sin(radianArray[i]);

                pointArray.push({ x: x, y: y });
            }

            // console.log("三角形三座標", pointArray);

            //排序後最長邊固定為0,2
            //計算座標差
            let deltaX = pointArray[0].x - pointArray[2].x;
            let deltaY = pointArray[0].y - pointArray[2].y;

            // console.log("最長邊座標差x, y:", deltaX, deltaY);

            //若y = 0則表示已是平行
            if (deltaY == 0) {
                console.log("已經是水平");
                rotate = 180;
            }
            //若x = 0則表示是垂直
            else if (deltaX == 0) {
                console.log("是垂直");
                rotate = -90;
            } else {
                pointArray = this.rotateAngle(pointArray);
                rotate = 180;
            }

            let rect = new fabric.Polygon(pointArray, {
                angle: rotate,
                left: 100,
                top: 125,
                fill: DEFINE.COLOR.TRANSPARENT,
                stroke: DEFINE.COLOR.MATH_TOOL.BLACK_0_0_0,
                strokeWidth: 5,
                originX: "center",
                originY: "center",
                transparentCorners: false,
                selectable: false,
                evented: false
            });

            this.triangleCanvas.add(rect);
            this.triangleCanvas.renderAll();
        },
        //將三角形最長邊改為平行（重設座標）        
        rotateAngle(pointArray) {
            //計算新index 2座標
            //計算距離
            let deltaX = pointArray[2].x - pointArray[0].x;
            let deltaY = pointArray[2].y - pointArray[0].y;
            let distance = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));

            pointArray[2].x = pointArray[0].x + distance;
            pointArray[2].y = pointArray[0].y;
            //計算index 2座標角度以計算座標1
            //計算弧度
            let radian2 = Math.atan(deltaY / deltaX);
            //弧度轉角度
            let angle2 = radian2 * 180 / Math.PI;

            //計算新index 1座標
            //計算斜率
            deltaX = pointArray[1].x - pointArray[0].x;
            deltaY = pointArray[1].y - pointArray[0].y;
            //計算弧度
            let radian1 = Math.atan(deltaY / deltaX);
            //弧度轉角度
            let angle1 = radian1 * 180 / Math.PI;

            //計算新角度及弧度
            let angle = angle1 - angle2;
            let radian = angle / 180 * Math.PI;

            //新斜率
            let slope = Math.tan(radian);
            distance = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));

            //以新斜率及距離求新座標
            deltaX = distance / Math.sqrt(Math.pow(slope, 2) + 1);
            deltaY = deltaX * slope;

            pointArray[1].x = pointArray[0].x + deltaX;
            pointArray[1].y = pointArray[0].y + deltaY;

            return pointArray;
        },
        //將邊長排序，由長到短
        sortSide(triangleSideObj) {
            if (triangleSideObj.a < triangleSideObj.b) {
                let t = triangleSideObj.a;
                triangleSideObj.a = triangleSideObj.b;
                triangleSideObj.b = t;
            }

            if (triangleSideObj.b < triangleSideObj.c) {
                let t = triangleSideObj.b;
                triangleSideObj.b = triangleSideObj.c;
                triangleSideObj.c = t;
            }

            if (triangleSideObj.a < triangleSideObj.b) {
                let t = triangleSideObj.a;
                triangleSideObj.a = triangleSideObj.b;
                triangleSideObj.b = t;
            }
        },
        //#endregion

        //#region 多邊形
        polgonUpdate() {
            //非數字清除
            this.polygonToolInput = this.polygonToolInput.replace(/\D/g, '');

            //邊數不可大於99、小於3
            if (this.polygonToolInput > 99) this.polygonToolInput = 99;
            if (this.polygonToolInput < 3) this.polygonToolInput = 3;

            this.preViewPolygonImage();
        },
        preViewPolygonImage() {
            this.polygonCanvas.clear();

            const self = this;
            const angle = 360 / this.polygonToolInput;
            const radius = 100;  //預設半徑

            //四邊形要特別旋轉成正方形角度，其餘旋轉成起點在正上方
            let rotateAngle = this.polygonToolInput == 4 ? 45 : 90;

            let pointArray = [];

            for (let i = 0; i < this.polygonToolInput; i++) {
                //弧度
                let radian = (i * angle - rotateAngle) * Math.PI / 180;

                //計算新的x, y座標
                let x = radius * Math.cos(radian);
                let y = radius * Math.sin(radian);

                pointArray.push({ x: x, y: y });
            }

            let rect = new fabric.Polygon(pointArray, {
                tag: "createPolygon" + new Date().getTime(),
                top: 125,
                left: 125,
                fill: DEFINE.COLOR.TRANSPARENT,
                stroke: DEFINE.COLOR.MATH_TOOL.BLACK_0_0_0,
                strokeWidth: 5,
                originX: "center",
                originY: "center",
                selectable: false,
                evented: false
            });

            self.polygonCanvas.add(rect);
            self.polygonCanvas.renderAll();
        },

        //#endregion

    },
    mounted() {
        //建立三個介面的預覽畫布場景
        this.angleCanvas = new fabric.Canvas("AngleCanvas", {
            selection: false,
        });
        this.triangleCanvas = new fabric.Canvas("TriangleCanvas", {
            selection: false,
        });
        this.polygonCanvas = new fabric.Canvas("PolygonCanvas", {
            selection: false,
        });

        //角度初始化        
        this.preViewAngleImage();

        //三角形初始化
        this.preViewTriangleImage();

        //多邊形初始化
        this.preViewPolygonImage();

        for(let i = 0; i < 3; i++) {
            this.handleTriangleAngles.push(DEBOUNCE(this.editTriangleAngle.bind(this, [i])));
        }
        for(let i = 0; i < 3; i++) {
            this.handleTriangleLengths.push(DEBOUNCE(this.editTriangleLength.bind(this, [i])));
        }
    },
};
</script>

<style src="../../assets/css/PolygonCreater.css" scoped>

</style>
